import { render, staticRenderFns } from "./TranslateFeedForm.vue?vue&type=template&id=43037ed4&scoped=true&"
import script from "./TranslateFeedForm.vue?vue&type=script&lang=js&"
export * from "./TranslateFeedForm.vue?vue&type=script&lang=js&"
import style0 from "./TranslateFeedForm.vue?vue&type=style&index=0&id=43037ed4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43037ed4",
  null
  
)

export default component.exports